import type { oz } from '@vy/utils';
import { NewCreateProductDialogFormSchema } from './new-create-product-dialog-form-schema';

export const CreateProductDialogFormInputSchema = NewCreateProductDialogFormSchema.partial();

export type CreateProductDialogFormInput = oz.infer<typeof CreateProductDialogFormInputSchema>;
